__turbopack_context__.v({
  "answer": "locationFAQ-module-scss-module__j8foKG__answer",
  "chevron": "locationFAQ-module-scss-module__j8foKG__chevron",
  "faqItem": "locationFAQ-module-scss-module__j8foKG__faqItem",
  "faqItemExpanded": "locationFAQ-module-scss-module__j8foKG__faqItemExpanded",
  "faqList": "locationFAQ-module-scss-module__j8foKG__faqList",
  "locationFaq": "locationFAQ-module-scss-module__j8foKG__locationFaq",
  "question": "locationFAQ-module-scss-module__j8foKG__question",
  "questionButton": "locationFAQ-module-scss-module__j8foKG__questionButton",
  "title": "locationFAQ-module-scss-module__j8foKG__title",
});
